import React from 'react';
import Menu from './Menu';
import { useEffect } from 'react';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { SITE_URL } from './constants';

import vl6 from './images/about/velimir-lesikov-machine-learning.png';
import shape_38 from './images/shape/shape_38.svg';
import shape_39 from './images/shape/shape_39.svg';

// credentials
import gen_ai_cred_early_adopter from './images/credentials/aws-certified-ai-developer-early-adopter.png';
import gen_ai_cred from './images/credentials/aws-certified-ai-developer-professional.png';
import ml_cred from './images/credentials/aws-certified-machine-learning-specialty.png';
import a_cred from './images/credentials/aws-certified-solutions-architect-professional.png';

function About() {

	useEffect(() => {
		window.scrollTo(0, 0);
	});

	return (
		<React.Fragment>
			<Helmet>
				<title>About Vel Lesikov - AI/ML Engineer & Founder | CaptainMe.AI</title>
				<meta name="description" content='Velimir (Vel) Lesikov, Principal Software & Machine Learning Engineer. AWS Certified ML Specialist & Solutions Architect Professional. Stanford AI Certificate. Expert in LLM, computer vision, and agentic AI systems.'></meta>
				<meta name="keywords" content="Vel Lesikov, machine learning engineer, AI consultant, AWS certified, Stanford AI, LLM expert, computer vision, agentic AI, PyTorch, AWS Bedrock"></meta>
				<link rel="canonical" href={`${SITE_URL}/about`} />
				<meta property="og:title" content='About Vel Lesikov - AI/ML Engineer & Founder | CaptainMe.AI'></meta>
				<meta property="og:description" content='Principal ML Engineer with AWS certifications and Stanford AI certificate. Expert in LLM, computer vision, and agentic AI systems.'></meta>
				<meta property="og:type" content="profile"></meta>
				<meta property="og:url" content={`${SITE_URL}/about`}></meta>
				<meta property="og:image" content={`${SITE_URL}/ogg-captain-me-ai.jpg`}></meta>
				<meta name="twitter:card" content="summary_large_image"></meta>
				<meta name="twitter:title" content="About Vel Lesikov - AI/ML Engineer"></meta>
				<meta name="twitter:description" content="Principal ML Engineer specializing in LLM, computer vision, and agentic AI systems."></meta>
				<meta name="twitter:image" content={`${SITE_URL}/ogg-captain-me-ai.jpg`}></meta>
				<script type="application/ld+json">{JSON.stringify({
					"@context": "https://schema.org",
					"@type": "Person",
					"name": "Velimir Lesikov",
					"alternateName": "Vel Lesikov",
					"jobTitle": "Principal Software & Machine Learning Engineer",
					"description": "Founder and Principal Software & Machine Learning Engineer at CaptainMe AI. AWS Certified ML Specialist & Solutions Architect Professional. Stanford AI Certificate holder.",
					"url": `${SITE_URL}/about`,
					"image": `${SITE_URL}/ogg-captain-me-ai.jpg`,
					"worksFor": {
						"@type": "Organization",
						"name": "CaptainMe AI",
						"url": SITE_URL
					},
					"alumniOf": [
						{"@type": "CollegeOrUniversity", "name": "California State University, Northridge", "alternateName": "CSUN"},
						{"@type": "CollegeOrUniversity", "name": "Stanford University"}
					],
					"hasCredential": [
						{
							"@type": "EducationalOccupationalCredential",
							"name": "Artificial Intelligence Professional Certificate",
							"credentialCategory": "Professional Certificate",
							"recognizedBy": {"@type": "CollegeOrUniversity", "name": "Stanford University"}
						},
						{
							"@type": "EducationalOccupationalCredential",
							"name": "AWS Certified Generative AI Developer - Professional",
							"credentialCategory": "Professional Certification",
							"recognizedBy": {"@type": "Organization", "name": "Amazon Web Services"}
						},
						{
							"@type": "EducationalOccupationalCredential",
							"name": "AWS Certified Solutions Architect - Professional",
							"credentialCategory": "Professional Certification",
							"recognizedBy": {"@type": "Organization", "name": "Amazon Web Services"}
						},
						{
							"@type": "EducationalOccupationalCredential",
							"name": "AWS Certified Machine Learning - Specialty",
							"credentialCategory": "Professional Certification",
							"recognizedBy": {"@type": "Organization", "name": "Amazon Web Services"}
						}
					],
					"knowsAbout": [
						"Machine Learning", "Computer Vision", "Large Language Models",
						"AWS Cloud Architecture", "Data Engineering", "PyTorch",
						"Agentic AI", "Predictive Analytics", "NLP"
					],
					"sameAs": [
						"https://www.linkedin.com/in/velimir-lesikov/",
						"https://github.com/velles",
						"https://medium.com/@vel-lesikov"
					]
				})}</script>
				<script type="application/ld+json">{JSON.stringify({
					"@context": "https://schema.org",
					"@type": "BreadcrumbList",
					"itemListElement": [
						{"@type": "ListItem", "position": 1, "name": "Home", "item": `${SITE_URL}/`},
						{"@type": "ListItem", "position": 2, "name": "About", "item": `${SITE_URL}/about`}
					]
				})}</script>
			</Helmet>

			< Menu />

			{/**
			=============================================
				Theme Inner Banner / Header
			============================================== 
      */}
			<div className="theme-inner-banner">
				<div className="container">
					<h2 className="intro-title text-center">Leadership</h2>
					<ul className="page-breadcrumb style-none d-flex justify-content-center">
						<li>
							<Link to="/">Home</Link>
						</li>
						<li className="current-page">About</li>
					</ul>
				</div>
				<img src={shape_38} alt="" className="shapes shape-one" />
				<img src={shape_39} alt="" className="shapes shape-two" />
			</div>

			{/**
			=====================================================
				About Detail
			=====================================================
      */}
			<div className="team-details mt-20 mb-160 lg-mt-10 lg-mb-10">
				<div className="container">
					<div className="row">
						<div className="col-xxl-10 col-lg-12 col-md-10 m-auto">
							<div className="d-lg-flex align-items-center">

								<div className="bio-title-wrapper">
									<div className="name">Vel Lesikov</div>
									<div className="position"> Principal Software & Machine Learning Engineer / Founder</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-xxl-10 col-lg-12 col-md-10 m-auto">
							<div className="main-bg d-lg-flex">

								<div className="img-meta pt-40">
									<img src={vl6} alt="Velimir Lesikov about - CaptainMe.AI - Principal Software & Machine Learning Engineer" className="w-100" />
								</div>

								<div className="text-wrapper align-items-center">
									<h6>BIO & EXPERIENCE</h6>
									<p className="">Velimir (Vel) Lesikov is the founder and Principal Software & Machine Learning Engineer at CaptainMe AI. His work centers on data-driven solutions—designing intelligent software systems from the ground up, as well as improving and scaling existing platforms.
									</p>
									<p className="pb-10">
										Velimir has a proven track record of building large-scale online systems from scratch and contributing across the entire technical stack. His experience ranges from operating as a solo engineer to leading large teams on multimillion-dollar projects.
									</p>
									<p className="pb-10">
										Previously, he managed and led the technical development of a SaaS advertising product from inception through a 10x company growth and a successful acquisition in under five years.
									</p>
									<p className="pb-10">
										As the technical leader at CaptainMe AI, he has helped e-commerce and fit-tech companies develop new solutions, realize the potential of their data, and scale their systems effectively.
									</p>
									<p className="pb-10">
										Velimir consistently seeks innovative ways to apply AI to real-world problems. His expertise includes AI problem-solving and ML solution design, where he leverages simple, robust heuristics to address complex marketing and business challenges, with a growing focus on agentic AI solutions.
									</p>
									<p className="pb-10">
										As a Machine Learning Engineer, he has architected a variety of ML, NLP/LLM, and Computer Vision solutions. He has hands-on experience with ETL, data pipeline development, data sanitation, and data augmentation techniques. His background as a Privacy Engineer ensures that every AI product he works on is privacy-aware and user-centric.
									</p>
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="main-bg m-auto d-lg-flex">
							<div className="text-wrapper creds">
								<h6>Credentials</h6>
								<ul>
									<li>Bachelor's degree in Computer Science from CSUN</li>
									<li>
										<a href="https://digitalcredential.stanford.edu/check/AC7A1106CF6A45F041E7F2B0A7A93044B0CBADCDFFBD8F46A4A84FC01E2CC74DYUxYTWVld2V0VFAzU2Z6TjdvbktpdWtGNGhoeDJzUFkwVEt1L2tSRGJscWdYSnpU" rel="noreferrer" target="_blank">
											Artificial Intelligence Professional Certificate from Stanford University
										</a>
									</li>
									<li>
										<a href="https://www.credly.com/badges/264fe391-f321-42ea-a6e9-0f3dab787d8c" rel="noreferrer" target="_blank">
											AWS Certified Generative AI Developer - Professional
										</a>
									</li>
									<li>
										<a href="https://www.credly.com/badges/0db46f4c-3f60-413d-aa31-8d5e56982d2d/public_url" rel="noreferrer" target="_blank">
											AWS Certified Solutions Architect – Professional
										</a>
									</li>
									<li>
										<a href="https://www.credly.com/badges/bf20eeea-2ba4-4a54-9e2b-eb9127d4f748/public_url" rel="noreferrer" target="_blank">
											AWS Certified Machine Learning – Specialty
										</a>
									</li>
								</ul>
							</div>

							<div className="column col-md-10 d-flex flex-wrap creds-icons">
								<div className="d-flex" style={{width: '50%', padding: '15px'}}>
									<a href="https://www.credly.com/badges/264fe391-f321-42ea-a6e9-0f3dab787d8c" rel="noreferrer" target="_blank">
										<img src={gen_ai_cred} style={{maxWidth: '200px'}} alt="" className="m-auto" />
									</a>
								</div>
								<div className="d-flex" style={{width: '50%', padding: '15px'}}>
									<a href="https://www.credly.com/badges/0db46f4c-3f60-413d-aa31-8d5e56982d2d/public_url" rel="noreferrer" target="_blank">
										<img src={gen_ai_cred_early_adopter} style={{maxWidth: '200px'}} alt="" className="m-auto" />
									</a>
								</div>
								<div className="d-flex" style={{width: '50%', padding: '15px'}}>
									<a href="https://www.credly.com/badges/bf20eeea-2ba4-4a54-9e2b-eb9127d4f748/public_url" rel="noreferrer" target="_blank">
										<img src={ml_cred} style={{maxWidth: '200px'}} alt="" className="m-auto" />
									</a>
								</div>
								<div className="d-flex" style={{width: '50%', padding: '15px'}}>
									<a href="https://www.credly.com/badges/0db46f4c-3f60-413d-aa31-8d5e56982d2d/public_url" rel="noreferrer" target="_blank">
										<img src={a_cred} style={{maxWidth: '200px'}} alt="" className="m-auto" />
									</a>
								</div>
							</div>
						</div>
					</div>

					<div className="row">
						<div className="col-xxl-10 col-lg-12 col-md-10 m-auto">
							<div className="main-bg d-lg-flex align-items-center">
								<div className="text-wrapper">
									<h6>FOLLOW & CONTACT</h6>
									<ul className="social-icon style-none d-flex pt-15">
										<li><a href="https://www.linkedin.com/in/velimir-lesikov/" target="_blank" rel="noreferrer"><i className="fab fa-linkedin"></i></a></li>
										<li><a href="https://github.com/velles" target="_blank" rel="noreferrer"><i className="fab fa-github"></i></a></li>
										<li><a href="https://medium.com/@vel-lesikov" target="_blank" rel="noreferrer"><i className="fab fa-medium"></i></a></li>
										<li><a href="mailto:vel@captainme.com" target="_blank" rel="noreferrer"><i className="far fa-envelope"></i></a></li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}

export default About;
